import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React from 'react';

import { useCustomerInfoQueryState } from 'src/hooks/use-customer-info-query';
import { selectServiceLocation } from 'src/state/address/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { i18n } from 'src/i18n';

import { StyledFooterText, StyledFooterUserInfo } from './footer-customer-information.styled';

export const FooterCustomerInformation = () => {
  const serviceLocation = useAppSelector(selectServiceLocation);
  const { userInfo } = useCustomerInfoQueryState();

  if (!userInfo) {
    return null;
  }

  const { userDetails } = userInfo;

  return (
    <StyledFooterUserInfo>
      <StyledFooterText component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} data-hj-suppress={true}>
        {userDetails.firstName} {userDetails.lastName}
      </StyledFooterText>
      {serviceLocation && (
        <StyledFooterText component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} data-hj-suppress={true}>
          {serviceLocation.address.streetAddress} {serviceLocation.address.streetAddress2}
        </StyledFooterText>
      )}
      <StyledFooterText component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} data-hj-suppress={true}>
        {i18n.component.footer.customerNumber}: {userDetails.billingAccountId}
      </StyledFooterText>
    </StyledFooterUserInfo>
  );
};
